// extracted by mini-css-extract-plugin
export default {"item":"Item_item__GzUOd","photo":"Item_photo__Xg2x9","description":"Item_description__X0xln","bottom":"Item_bottom__Q-9Fd"};